// eslint-disable-next-line no-unused-vars
import { Extension, mergeAttributes } from "@tiptap/core";
import { VueRenderer } from "@tiptap/vue-3";
import Suggestion from "@tiptap/suggestion";
import tippy from "tippy.js";
import TeamingTiptapSlashCommands from "./TeamingTiptapSlashCommands";

import debugFactory from "debug";
// eslint-disable-next-line no-unused-vars
const debug = debugFactory( "teaming:tiptap:slash-commands" );

const forbiddenAncestorNodeTypes = [
	"teaming-commitment",
	"teaming-decision",
	"teaming-topic",
];

const extension = Extension.create( {
	name: "teaming-slash-commands",

	addProseMirrorPlugins() {
		return [
			// eslint-disable-next-line new-cap
			Suggestion( {
				editor: this.editor,

				char: "/",
				allowSpaces: false,
				startOfLine: true,
				prefixSpace: false,

				// "props" is the selected item: { title:String, command:Function }
				command: ( { editor, range, props, } ) => {
					props.command( { editor, range, } );
				},

				// "query" is what the user types after the slash
				items: ( { query, } ) => {
					query = query.toLowerCase();

					return [
						{
							key: "topic",
							icon: [ "fac", "topic-solid", ],
							command: ( { editor, range, } ) => {
								editor
									.chain()
									.focus()
									.deleteRange( range )
									.setTopic()
									.run();
							},
						},
						{
							key: "actionitem",
							icon: [ "fas", "check-square", ],
							command: ( { editor, range, } ) => {
								editor
									.chain()
									.focus()
									.deleteRange( range )
									.setCommitment()
									.run();
							},
						},
						{
							key: "decision",
							icon: [ "fas", "gavel", ],
							command: ( { editor, range, } ) => {
								editor
									.chain()
									.focus()
									.deleteRange( range )
									.setDecision()
									.run();
							},
						},
					].filter( item => item.key.startsWith( query ) );
				},

				render: () => {
					let component = null;
					let popup = null;

					return {
						onStart: props => {
							component = new VueRenderer( TeamingTiptapSlashCommands, {
								// using vue 2:
								// parent: this,
								// propsData: props,
								props,
								editor: props.editor,
							} );

							if ( !props.clientRect ) {
								return;
							}

							popup = tippy( "body", {
								getReferenceClientRect: props.clientRect,
								appendTo: () => document.body,
								content: component.element,
								showOnCreate: true,
								interactive: true,
								trigger: "manual",
								placement: "bottom-start",
							} );
						},

						onUpdate( props ) {
							component.updateProps( props );

							if ( !props.clientRect ) {
								return;
							}

							popup[ 0 ].setProps( {
								getReferenceClientRect: props.clientRect,
							} );
						},

						onKeyDown( props ) {
							if ( props.event.key === "Escape" ) {
								popup[ 0 ].hide();

								return true;
							}

							return component.ref?.onKeyDown( props );
						},

						onExit() {
							popup[ 0 ].destroy();
							component.destroy();
						},
					};
				},

				allow: ( { state, } ) => {
					const path = state?.selection?.$anchor?.path || [];
					const forbiddenAncestor = path.find( node => forbiddenAncestorNodeTypes.includes( node?.type?.name ) );
					return !forbiddenAncestor;
				},
			} ),
		];
	},
} );

export default extension;

